module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 110.7f0d334e.png";